import type { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const TabsLoadingSkeleton: FC = () => (
  <div className="flex items-center space-x-4 my-6">
    <div className="w-48">
      <div className="flex">
        <div className="flex-1 ml-3">
          <Skeleton className="flex-1 w-full h-3" />
        </div>

        <div className="w-6 h-6 -mt-1 mx-3">
          <Skeleton className="w-6 h-6" circle />
        </div>
      </div>

      <Skeleton className="h-[2px]" />
    </div>

    <div className="w-48">
      <div className="flex">
        <div className="flex-1 ml-3">
          <Skeleton className="flex-1 w-full h-3" />
        </div>

        <div className="w-6 h-6 -mt-1 mx-3">
          <Skeleton className="w-6 h-6" circle />
        </div>
      </div>

      <Skeleton className="h-[2px]" />
    </div>

    <div className="w-48">
      <div className="flex">
        <div className="flex-1 ml-3">
          <Skeleton className="flex-1 w-full h-3" />
        </div>

        <div className="w-6 h-6 -mt-1 mx-3">
          <Skeleton className="w-6 h-6" circle />
        </div>
      </div>

      <Skeleton className="h-[2px]" />
    </div>

    <div className="w-48">
      <div className="flex">
        <div className="flex-1 ml-3">
          <Skeleton className="flex-1 w-full h-3" />
        </div>

        <div className="w-6 h-6 -mt-1 mx-3">
          <Skeleton className="w-6 h-6" circle />
        </div>
      </div>

      <Skeleton className="h-[2px]" />
    </div>
  </div>
);

export default TabsLoadingSkeleton;
